import { useContext } from "react";

import { AppContext } from "ui/app";

export function useAppContext() {
  return useContext(AppContext);
}
